export const maxApiKeys = 10;
